<template>
    <v-form>
        <div class="az-form-content">
            <v-container fluid grid-list-xl>
                <detalhes-dados-licitacao-dados-gerais
                    v-if="licitacaoCarregada"
                    v-model="licitacaoLegadoAtualizacao"
                    :lotes="lotes"
                />
            </v-container>
        </div>
    </v-form>
</template>

<script>
import {mapActions, mapState} from 'vuex'
import DetalhesDadosLicitacaoDadosGerais from './components/dados-gerais/DetalheDadosLicitacaoDadosGerais'
import {actionTypes} from '@/commons/constants'
import _ from 'lodash'

export default {
    components: {DetalhesDadosLicitacaoDadosGerais},
    data() {
        return {
            licitacaoLegadoAtualizacao: {},
            licitacaoCarregada: false,
            lotes: []
        }
    },
    computed: {
        ...mapState(['licitacaoLegado'])
    },
    created() {
      this.buscarLotes()
    },
    async mounted() {
        await this.buscarLicitacaoLegado(this.$route.params.id)
        this.licitacaoCarregada = true
        await this.atribuirLicitacao()
    },
    methods: {
        async atribuirLicitacao() {
            this.licitacaoLegadoAtualizacao = _.cloneDeep(this.licitacaoLegado)
        },
        async buscarLotes() {
            const lotesBuscados = await this.buscarLotesPregaoUsiga(this.$route.params.id)

            this.lotes = [{ id: 0, descricao: "TODOS" }, ...lotesBuscados]
        },
        ...mapActions([
            actionTypes.BUSCAR_LICITACAO_LEGADO,
            actionTypes.BUSCAR_LOTES_PREGAO_USIGA
        ])
    }
}
</script>
